import { render, staticRenderFns } from "./BoostBanner.vue?vue&type=template&id=a817382c&scoped=true"
import script from "./BoostBanner.vue?vue&type=script&lang=js"
export * from "./BoostBanner.vue?vue&type=script&lang=js"
import style0 from "./BoostBanner.vue?vue&type=style&index=0&id=a817382c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a817382c",
  null
  
)

export default component.exports